// import MyCube from "@/components/shellComponents/modals/myCube/MyCube";
import Settings from "@/components/shellComponents/modals/settings/Settings";
import NotificationsTray from "@/components/shellComponents/NotificationsTray";
import AnalyticsIndex from "@/components/widgets/analytics/AnalyticsIndex";
import AxeCreationIndex from "@/components/widgets/axeCreation/AxeCreationIndex";
import CreationIndex from "@/components/widgets/Creation/CreationIndex";
import FirstLoad from "@/components/widgets/loading/FirstLoad";
import PriceIndex from "@/components/widgets/prices/PriceIndex";
import SwapCurveIndex from "@/components/widgets/swapCurve/SwapCurveIndex";
import ActionSummaryIndex from "@/components/widgets/tradeActionSummary/ActionSummaryIndex";
import TradeFromScratchIndex from "@/components/widgets/tradeFromScratch/TradeFromScratchIndex";
import TradeTileIndex from "@/components/widgets/tradeTile/TradeTileIndex";

//----------List of all available widgets that can be accessed by user throughout the app.----------
export const componentsList: any = {
  Price: PriceIndex,
  Analytics: AnalyticsIndex,
  AxeCreation: AxeCreationIndex,
  TradeCreation: CreationIndex,
  ActionSummary: ActionSummaryIndex,
  TradeTile: TradeTileIndex,
  SwapCurve: SwapCurveIndex,
  TradeFromScratch: TradeFromScratchIndex,
  Settings: Settings,
  // MyCube: MyCube,
  NotificationsTray: NotificationsTray,
  FirstLoad: FirstLoad,
};
